export default {
    //获取首页轮播图
    getBannerList: "client/market/skipAuth/advertising/show",
    //获取订单统计
    getOrderStatistics: "client/mobile/skipAuth/statistics/index",
    //获取商品
    getProductList: "client/market/skipAuth/recommend/home/productItem",
    //获取轮播图
    getBanner: "client/market/skipAuth/advertising",
};
